import React from "react";
import "./Sixth.css";
import { Container } from "react-bootstrap";
import mobApp from "../../../../Asset/mobileApp/mobile-apps-2.svg";
import { useNavigate } from "react-router-dom";

const Sixth = () => {
  const navigate = useNavigate();

  const hendleClick = () => {
    navigate("/ContactUs");
  };
  return (
    <>
      <section className="sixth-mobileApp-section">
        <Container>
          <div className="mob-dev-cta">
            <div className="row">
              <div className="col-xl-8 col-md-8">
                <div className="sec-6-cta-card">
                  <h3>
                    Be Part of the $935 Billion Mobile App Market and Scale{" "}
                    <strong className="text-skyblue">
                      Your Business With a Custom Mobile App Today!
                    </strong>
                  </h3>
                  <p onClick={hendleClick} className="btn btn-primary">
                    Contact Us Today
                  </p>
                </div>
              </div>
              <div className="col-xl-4 col-md-4">
                <div className="cta-bg">
                  <img alt="main" src={mobApp} className="w-100" />
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Sixth;
